// React/Next imports
import { useEffect, useState } from 'react';
// Components
import { useInterval } from 'react-use';

// Hooks
import useUser from '@/utils/hooks/swr/useUser';

// Constants/Libs
import { post } from '@/utils/client';

import { HUBSPOT_CONVERSATION_TOKEN } from '@/lib/routes/apiEndpoints';

const HUBSPOT_SCRIPT_ID = 'hs-script-loader';
const HUBSPOT_SCRIPT_LOAD_DELAY = 500;

export default function HubSpotIdentification() {
    const { user } = useUser();
    const [isLoaded, setIsLoaded] = useState(false);

    const createToken = async () => {
        return await post(HUBSPOT_CONVERSATION_TOKEN).then((response) => response.data?.token);
    };

    const loadWidget = async () => {
        const token = user.first_name && user.last_name ? await createToken() : null;

        if (!token) {
            return;
        }

        window.HubSpotConversations?.clear?.({ resetWidget: true });
        window.hsConversationsSettings = {
            identificationEmail: user.email,
            identificationToken: token
        };

        window.HubSpotConversations?.widget?.load?.();
    };

    useEffect(() => {
        window.hsConversationsSettings = {
            loadImmediately: false
        };
        if (!user) {
            window.HubSpotConversations?.widget?.remove?.();
            window.HubSpotConversations?.clear?.({ resetWidget: true });
            window.HubSpotConversations?.widget?.refresh?.({ openToNewThread: true });
            return;
        }
        if (!isLoaded) return;

        loadWidget();
    }, [user?.email, isLoaded]);

    useInterval(
        () => {
            if (document?.getElementById(HUBSPOT_SCRIPT_ID)) {
                setIsLoaded(true);
            }
        },
        isLoaded ? null : HUBSPOT_SCRIPT_LOAD_DELAY
    );

    return null;
}
